import React, { ReactNode, CSSProperties, HTMLAttributes } from "react";

import { vars } from "@puzzle/theme";

// Hardcoded for now, but should be dynamic
type SemanticSurfaceColors =
  | "primary-moreSubdue"
  | "primary-subdue"
  | "primary-base"
  | "primary-highlight"
  | "monetize-moreSubdue"
  | "monetize-subdue"
  | "monetize-base"
  | "monetize-highlight"
  | "error-moreSubdue"
  | "error-subdue"
  | "error-base"
  | "error-highlight"
  | "warning-moreSubdue"
  | "warning-subdue"
  | "warning-base"
  | "warning-highlight"
  | "info-mostSubdue"
  | "info-base"
  | "transparentInverted-subdue"
  | "transparentInverted-base"
  | "transparentInverted-highlight"
  | "transparent-moreSubdue"
  | "transparent-subdue"
  | "transparent-base"
  | "transparent-highlight"
  | "neutral-subdue"
  | "neutral-base"
  | "neutral-highlight"
  | "neutral-moreHighlight"
  | "neutral-mostHighlight";

const getSurfaceColor = (surface: SemanticSurfaceColors | undefined) => {
  if (!surface) {
    return undefined;
  }
  const token = `surface-${surface}` as const;

  return vars.colors[token];
};

export type BoxProps = {
  /**
   * The content of the box.
   */
  children?: ReactNode;
  /**
   * The CSS properties of the box.
   */
  css?: CSSProperties;
  /**
   * The semantic surface color of the box.
   */
  surface?: SemanticSurfaceColors;
} & HTMLAttributes<HTMLDivElement>;

export const Box = ({ css, children, surface, ...divProps }: BoxProps) => {
  const cssStyles = {
    ...css,
    ...(surface && { backgroundColor: getSurfaceColor(surface) }),
  };

  return (
    <div style={cssStyles} {...divProps}>
      {children}
    </div>
  );
};
